module.exports = __webpack_public_path__ + "img/arrow-right-363.d572ec76.svg";